/**
 * Open the Play Store listing so users can rate USA Visible.
 * Prefer market:// on Android; fall back to the HTTPS store URL.
 */
const PLAY_STORE_PACKAGE = 'com.usavisible.app';
const PLAY_STORE_HTTPS = `https://play.google.com/store/apps/details?id=${PLAY_STORE_PACKAGE}`;
const PLAY_STORE_MARKET = `market://details?id=${PLAY_STORE_PACKAGE}`;

export function openRateApp(): void {
  if (typeof window === 'undefined') return;

  try {
    // Capacitor / Android WebView: try market intent first
    const isAndroid =
      /Android/i.test(navigator.userAgent) ||
      // @ts-expect-error Capacitor may be present at runtime
      window.Capacitor?.getPlatform?.() === 'android';

    if (isAndroid) {
      window.location.href = PLAY_STORE_MARKET;
      // Fallback if market:// is blocked
      window.setTimeout(() => {
        window.open(PLAY_STORE_HTTPS, '_blank', 'noopener,noreferrer');
      }, 400);
      return;
    }
  } catch {
    // ignore and use HTTPS
  }

  window.open(PLAY_STORE_HTTPS, '_blank', 'noopener,noreferrer');
}
